import type { Meal } from '../../domain/types.js';
import type { Effort } from '../store/settings.js';

/**
 * `low` is 30 minutes, deliberately the same threshold the `quick` tag uses —
 * two names for one idea would drift apart the moment either changed.
 */
export const MAX_MINUTES: Record<Effort, number> = {
  low: 30,
  medium: 60,
  high: Number.POSITIVE_INFINITY,
};

export function fitsEffort(meal: Meal, effort: Effort): boolean {
  return meal.effortMinutes <= MAX_MINUTES[effort];
}

/** A low-effort night opens the picker already filtered. */
export function defaultFilterFor(effort: Effort): 'quick' | 'all' {
  return effort === 'low' ? 'quick' : 'all';
}
